module.exports = __webpack_public_path__ + "static/img/profile-icon14.4c7fede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon14.png
// module id = 2962
// module chunks = 1